/* eslint-disable react/prop-types */
import { useEffect, useState, useRef } from 'react'
import Calhau from './assets/chegou.webm'

const fullScreen = {
    position: 'absolute',
    left: '0px',
    top: '0px',
    width: '100%',
    height: '100%',
    opacity: 1,
}

const BTPCalhau = ({ cbFinished }) => {
    const [finished, setFinished] = useState(false)
    const timer = useRef(null)

    useEffect(() => {
        if (finished) {
            timer.current = setInterval(() => setFinished(true), 500)
            setFinished(false)
            cbFinished()
        }
        return () => clearInterval(timer.current)
    }, [cbFinished, finished])

    return (
        <video
            style={fullScreen}
            src={Calhau}
            onEnded={() => setFinished(true)}
            muted='muted'
            autoPlay='autoplay'
        />
    )
}

export default BTPCalhau
